import Cookies from 'js-cookie';
import { flow } from 'mobx-state-tree';

import { getStores } from '../..';

export const fetchMyLocationsList = flow(function* (self, bounds) {
  const { config } = getStores(self, 'config');

  if (config.gysService.useMock || !config.features.myLocations) return;

  const locations = Cookies.get('custom-pois');
  const existingLocations = JSON.parse(locations);

  self.list = existingLocations;
});
